import axios, { Method } from 'axios';
import { BASEURL } from 'enviroments/enviroments';

export const refreshToken = async () => {
  const userData = JSON.parse(localStorage.getItem('user') || 'null')
    try {
      const response = await axios({
        method: 'POST' as Method,
        url: `${BASEURL}/ObtenerRefreshToken`,
        headers: {
          Authorization: `Bearer ${userData?.claims?._token}`,
          'Content-Type': 'application/json'
        },
        data: {
          _token: userData?.claims?._token,
          _refreshToken: userData?.claims?._refreshToken
        },
        responseType: 'json'
      });
      return response;    
    } catch (error: any) {
      console.error('Error:', error);
      const isObje = error !== null && typeof error === 'object'
      return isObje ? error?.response?.data?._mensaje : null;
    }
};